import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";

export default function KH1000210000() {
  const { i18n } = useTranslation();

  if (i18n.language === "en") {
    return (
      <>
        <p>
          1. Neak Oknha Dr. Quach Mengly
          <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".b" position="right" event="both">
            Executive Chairman
          </Tooltip>
        </p>
        <p>
          2. Mr. Quach Alex
          <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".c" position="right" event="both">
            Executive Director
          </Tooltip>
        </p>
        <p>
          3. Mr. Quach Paul
          <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".d" position="right" event="both">
            Executive Director
          </Tooltip>
        </p>
        <p>
          4. Lok Chumteav Ung Lyhong
          <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".e" position="right" event="both">
            Executive Director
          </Tooltip>
        </p>
        <p>
          5. Mr. Kong Vara
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".f" position="right" event="both">
            Independent Director
          </Tooltip>
        </p>
      </>
    );
  }
  return (
    <>
      <p>
        ១. អ្នកឧញ៉ា វេជ្ជបណ្ឌិត គួច ម៉េងលី
        <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".b" position="right" event="both">
          ប្រធានក្រុមប្រឹក្សាភិបាលប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ២. លោក គួច អាឡិច
        <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".c" position="right" event="both">
          អភិបាលប្រតិបត្តិ និងទីប្រឹក្សាជាន់ខ្ពស់
        </Tooltip>
      </p>
      <p>
        ៣. លោក គួច អាឡិច
        <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".d" position="right" event="both">
          អភិបាលប្រតិបត្តិ និងទីប្រឹក្សាជាន់ខ្ពស់
        </Tooltip>
      </p>
      <p>
        ៤. លោកជំទាវ អ៊ឺង លីហុង
        <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".e" position="right" event="both">
          អភិបាលប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៥. លោក គង់ វ៉ារ៉ា
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".f" position="right" event="both">
          អភិបាលឯករាជ្យ
        </Tooltip>
      </p>
    </>
  );
}
